import { useEffect, useState } from 'react'

import { LogoWithText } from '@/components/icons/bitlyft-logo'

const loadingMessages = [
	'Setting up your session...',
	'Verifying your credentials...',
	'Fetching your data...',
	'Finalizing setup...',
	'Almost there...',
	"Please wait, we're still working on it...",
]

const MESSAGE_INTERVAL = 3000

type AppLoaderProps = {
	isVisible: boolean
	showProgress?: boolean
}

export const AppLoader = ({
	isVisible,
	showProgress = false,
}: AppLoaderProps) => {
	const [messageIndex, setMessageIndex] = useState(0)

	// Message rotation - only when visible and showProgress is true
	useEffect(() => {
		if (!isVisible || !showProgress) return

		const interval = setInterval(() => {
			setMessageIndex((prev) => (prev + 1) % loadingMessages.length)
		}, MESSAGE_INTERVAL)

		return () => clearInterval(interval)
	}, [isVisible, showProgress])

	if (!isVisible) return null

	return (
		<div className="bg-background fixed inset-0 z-9999 flex items-center justify-center duration-200">
			<div className="flex max-w-sm flex-col items-center gap-8">
				<LogoWithText className="w-32 shrink-0 grow-0 animate-pulse" />

				{showProgress && (
					<p
						key={messageIndex}
						className="text-muted-foreground animate-in fade-in slide-in-from-bottom-2 text-center text-xs duration-200"
					>
						{loadingMessages[messageIndex]}
					</p>
				)}
			</div>
		</div>
	)
}
